import dayjs from '@/utils/dayjs'

export const getStartEnd = (option) => {
    const instance = dayjs()

    // This Release Period
    if (option === 0) {
        const east = instance.tz('America/New_York')
        const today = east.day()
        const thisFri = east.day(5)
        const lastFri = east.subtract(1, 'week').day(5)
        const nextFri = east.add(1, 'week').day(5)
        const start = today < 5 ? lastFri : thisFri
        const end = today < 5 ? thisFri : nextFri
        return {
            start: start.startOf('day'),
            end: end.startOf('day'),
            unit: 'day',
            inclusivity: '[)',
        }
    }

    // Today
    if (option === 1) {
        const unit = 'day'
        const start = instance.startOf(unit)
        const end = instance.endOf(unit)
        return { start, end }
    }

    // This Week
    if (option === 2) {
        const unit = 'week'
        const start = instance.startOf(unit)
        const end = instance.endOf(unit)
        return { start, end }
    }

    // This Month
    if (option === 3) {
        const unit = 'month'
        const start = instance.startOf(unit)
        const end = instance.endOf(unit)
        return { start, end }
    }

    // This Year
    if (option === 4) {
        const unit = 'year'
        const start = instance.startOf(unit)
        const end = instance.endOf(unit)
        return { start, end }
    }
}

export const createDescription = (start, end) => {
    return `Generated by https://github.com/donaldma/spotify-liked [${start} - ${end}]`
}